import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {  useNavigate } from 'react-router-dom';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { init } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, register,login} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined,RightOutlined
  } from '@ant-design/icons';
  import './index.less';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const St = (props) => {
    const { t } = useTranslation()


    const navigate = useNavigate()//hook事件路由跳转
    
    

     const go = (url)=>{
        if(url =="no"){
             message.error(t('g.暂未开放'))
           return
        }
           
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
            navigate(url,{
                state:{
                    address:props.address
                }
            })
        }



    useEffect(() => {
        // window.scrollTo(0, 0)
           
           
    }, 
    // eslint-disable-next-line
    [props.isLogin]);

    return (
        <>
            <Head/>
            

            
            
            <div className=' airbg  w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>
                            {/*  */}
                            <div className='w-full lg:w-1/3 px-0   min-h-[103px]  flex flex-row  '>
                               <img className=''  src={require('../../assets/st/banner.jpg')} style={{"width":"100%"}}></img>
                            </div>
                            {/*  */}
                            {/*  */}
                            <div onClick={()=>go("/staking")} className='recordbg mx-4 h-[150px] px-4 py-4  flex flex-row justify-start items-start relative'>
                                 <span className=' absolute right-5 mt-1 text-base flex flex-row items-center text-text1'><RightOutlined /></span>
                                <img className='mr-4 -mt-1'  src={require('../../assets/st/s1.jpg')} style={{"width":"150px"}}></img>
                                <div className=' w-full flex flex-col '>
                                    <span className='text-text1 text-sm'>{t('st.xAI 量化')}</span>
                                    <span className='text-text1 text-sm'>--</span>
                                    <span className='mt-2 text-gray-400 text-[8px] h-20 overflow-hidden'>{t('st.基于人工智能算法与大数据分析，xAI 量化为用户提供智能量化交易策略与自动化执行服务，帮助捕捉市场机会，优化资产配置，实现长期稳健增长')}</span>
                                </div>
                            </div>
                            <div onClick={()=>go("/game")} className='recordbg mx-4 h-[150px] px-4 py-4 mt-2 flex flex-row justify-start items-start relative'>
                                 <span className=' absolute right-5 mt-1 text-base flex flex-row items-center text-text1'><RightOutlined /></span>
                                <img className='mr-4 -mt-1'  src={require('../../assets/st/s2.jpg')} style={{"width":"150px"}}></img>
                                <div className=' w-full flex flex-col '>
                                    <span className='text-text1 text-sm'>{t('st.xAI 预测金库')}</span>
                                    <span className='text-text1 text-sm'>--</span>
                                    <span className='mt-2 text-gray-400 text-[8px] h-20 overflow-hidden'>{t('st.去中心化预测市场与收益金库的结合体。用户可参与全球热点事件预测，通过链上透明机制获取收益，让资产在安全可信的环境中持续增值')}</span>
                                </div>
                            </div>
                            <div onClick={()=>go("/pool")} className='recordbg mx-4 h-[150px] px-4 py-4 mt-2 flex flex-row justify-start items-start relative'>
                                 <span className=' absolute right-5 mt-1 text-base flex flex-row items-center text-text1'><RightOutlined /></span>
                                <img className='mr-4 -mt-0'  src={require('../../assets/st/s3.jpg')} style={{"width":"150px"}}></img>
                                <div className=' w-full flex flex-col '>
                                    <span className='text-text1 text-sm'>{t('st.LP 做市商')}</span>
                                    <span className='text-text1 text-sm'>--</span>
                                    <span className='mt-2 text-gray-400 text-[8px] h-20 overflow-hidden'>{t('st.成为生态流动性提供者，为交易市场注入活力。赚取交易手续费、平台激励及额外收益，实现资产利用率最大化')}</span>
                                </div>
                            </div>
                            <div onClick={()=>go("no")} className='recordbg mx-4 h-[150px] px-4 py-4 mt-2 flex flex-row justify-start items-start relative'>
                                 <span className=' absolute right-5 mt-1 text-base flex flex-row items-center text-text1'><RightOutlined /></span>
                                <img className='mr-4 -mt-0'  src={require('../../assets/st/s4.jpg')} style={{"width":"150px"}}></img>
                                <div className=' w-full flex flex-col '>
                                    <span className='text-text1 text-sm'>{t('st.SPACX Chat')}</span>
                                    <span className='text-text1 text-sm'>--</span>
                                    <span className='mt-2 text-gray-400 text-[8px] h-20 overflow-hidden'>{t('st.下一代 Web3 社交网络，支持链上身份、加密聊天、社区治理与项目互动，让沟通更安全，让连接更自由')}</span>
                                </div>
                            </div>
            
                            {/*  */}
                           
                            {/*  */}
                            <div className=' h-[100px]'></div>
                        </div>
            

                
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(St);
